<template>
  <div class="shop-navigation">
    <div class="shop-navigation__items">
      <button
        v-if="sets"
        class="shop-navigation__item"
        :class="{
          'shop-navigation__item--active shop-navigation__item--active-sets': value === 'sets',
        }"
        @click="$emit('input', 'sets')"
      >
        {{ $tc('shopSet', 2) }}
      </button>
      <button
        class="shop-navigation__item"
        v-for="(item, index) in items"
        :key="index"
        :class="{ 'shop-navigation__item--active': item.id === value }"
        @click="$emit('input', item.id)"
      >
        {{ item.label }}
        <span
          v-if="['signed', 'accepted'].includes(item.status)"
          class="shop-navigation__item-status"
        >
          <FontAwesomeIcon :icon="['fas', 'lock-alt']" class="text--success ml-1" />
        </span>
      </button>

      <button
        v-if="summary"
        class="shop-navigation__item"
        :class="{ 'shop-navigation__item--active': value === 'summary' }"
        @click="$emit('input', 'summary')"
      >
        {{ $t('shopSummary') }}
      </button>
      <ScrollIndicator :value="['left', 'right']" />
    </div>
  </div>
</template>

<script>
import ScrollIndicator from '@kvass/scroll-indicator'
export default {
  props: {
    value: String,
    items: Array,
    summary: Boolean,
    sets: Boolean,
  },
  components: {
    ScrollIndicator,
  },
}
</script>

<style lang="scss">
@import './styles/_mixins';

.shop-navigation {
  counter-reset: category-number;
  background-color: var(--primary);
  z-index: 2;

  &__items {
    width: 100%;
    text-align: center;
    white-space: nowrap;
    overflow-x: auto;
  }

  .scroll-indicator__arrow {
    border: 1px solid #dedede;
    border-radius: 20px 0 0 20px;
    border-right: none;
    width: 30px;
    height: 30px;
  }

  &__item {
    $counterSpace: 0.25rem;
    color: white;
    display: inline-block;
    margin: 1.5rem 0.5rem 0rem 0.5rem;
    text-align: center;
    white-space: nowrap;
    counter-increment: category-number;
    font-weight: bold;
    cursor: pointer;
    min-width: 150px;

    padding: 1rem 1rem + $counterSpace 1rem 1rem;
    opacity: 0.7;
    transition-property: opacity background-color;
    transition-duration: 150ms;
    transition-timing-function: ease-out;

    &--active {
      opacity: 1;
      border-radius: var(--border-radius) var(--border-radius) 0 0;
      background-color: white;
      color: black;
      &-sets {
        background-color: darken(white, 3%);
      }
    }

    &-status {
      font-weight: normal;
      font-size: 0.8em;
    }

    &:before {
      content: counter(category-number) '. ';
      font-weight: normal;
      margin-right: $counterSpace;
    }
  }
}
</style>
